import React from 'react'
import PropTypes from 'prop-types'
import { Card, styled } from '@mui/material'
import { Button } from 'components'
import { useTranslation } from 'react-i18next'
import ItemHeader from './ItemHeader'
import Attributes from './Attributes'

const StyledCard = styled(Card)(({ cardStyles }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 0.4rem 1.6rem 0 rgba(0, 0, 0, 0.05) !important',
    borderColor: 'none !important',
    borderStyle: 'solid !important',
    borderWidth: '0.1rem !important',
    borderImageSource:
        'linear-gradient(to right, rgba(1, 174, 143, 0), #04ab93 7%, #2c83bd 91%, rgba(48, 127, 193, 0)) !important',
    borderImageSlice: '1  !important',
    borderRadius: '0.8rem !important',
    paddingBottom: '1.2rem',
    ...cardStyles,
}))

const styles = {
    viewDetails: { margin: '1.6rem 2rem' },
}

const ItemCard = (props) => {
    const {
        item,
        onItemClick,
        buttonStyles,
        cardStyles,
        attributes,
        color,
        headerStyles,
        showDetailsButton = true,
    } = props

    const { t } = useTranslation()
    const headerAttribute = attributes.find((x) => x.isHeader)

    return (
        <StyledCard role="button" cardStyles={cardStyles}>
            <ItemHeader
                title={item[headerAttribute.name]}
                styles={headerStyles}
            />
            <Attributes item={item} attributes={attributes} color={color} />

            {showDetailsButton && (
                <Button.ViewDetails
                    styles={{ ...styles.viewDetails, ...buttonStyles }}
                    onClick={onItemClick}
                >
                    {t('ViewDetails')}
                </Button.ViewDetails>
            )}
        </StyledCard>
    )
}

ItemCard.propTypes = {
    item: PropTypes.object,
    onItemClick: PropTypes.func,
    className: PropTypes.string,
}

export default ItemCard
